// extracted by mini-css-extract-plugin
export default {"contact_wrapper":"GovernmentContact_contact_wrapper__ZtuoA","main":"GovernmentContact_main__R4Hik","contact_title":"GovernmentContact_contact_title__tS4sv"};